import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { HistoryTimeline } from '@/Ship/Components/History'

import { buildTaskHistoryEntries } from '../../Helpers/taskHistoryEntries'
import { TaskHistoryTabStore } from '../../Stores/TaskHistoryTabStore'

import type { TaskFormContextLike } from '../../Contracts/Crud.types'
import type { TaskFile } from '../../Contracts/Task.types'

interface Props {
    formContext?: TaskFormContextLike
}

/**
 * Вкладка «Історія змін» картки задачі (SPEC-008 §5.2).
 *
 * Per-mount стор `TaskHistoryTabStore` → `GET /services/tasks/{uuid}/history` (N9).
 * Стрічка — спільний `HistoryTimeline`: події по днях, що саме змінилося і хто.
 * Людей і коментарі бек пише ідентифікаторами — імена й тексти стор тягне сам,
 * назви файлів беремо з картки. `changedBy` порожнє → «Система».
 */
export const TaskHistoryTab = observer(({ formContext }: Props) => {
    const [store] = useState(() => new TaskHistoryTabStore())
    // `uuid` може з'явитися асинхронно після завантаження картки — читаємо з formContext.
    const uuid: string | undefined = formContext?.values?.uuid

    useEffect(() => {
        void store.load(uuid)
    }, [store, uuid])

    const files = new Map<string, string>()
    for (const file of (formContext?.values?.files ?? []) as TaskFile[]) {
        if (file?.uuid) files.set(file.uuid, file.originalName)
    }

    const entries = buildTaskHistoryEntries(store.history, {
        users: store.users,
        comments: store.comments,
        commentsLoaded: store.commentsLoaded,
        files,
        parent: formContext?.values?.parent,
    })

    const hidden = store.total - store.history.length

    return (
        <HistoryTimeline
            entries={entries}
            loading={store.loading}
            note={hidden > 0 ? `Показано останні ${store.history.length} подій із ${store.total}` : undefined}
        />
    )
})
